<div id="beyond">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Student’s Council</h4>
                  <div class="card-body">
                    <p class="inner-lead">A proactive student council shares responsibilities, learning vital life skills at every step. At our school, we believe in the importance of empowering our students and giving them a voice in the decision-making process. That's why we have a proactive student council in place to represent the interests of our student body. By participating in the student council, our students learn vital life skills such as leadership, communication, problem-solving, and teamwork.
                    </p>
                    <p class="inner-lead">Being a part of the student council also provides our students with opportunities to develop their own ideas and initiatives. By working collaboratively with their peers and school, students learn to be proactive, creative, and innovative, skills that will serve them well throughout their lives.
                    </p>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>